import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "../../components/toast";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { APP_PATH } from "../../api/backendPath";
import { ACTIONS_CREATE_FOLLOWUP_APPOINTMENT } from "../../action-types/actions";

export const createFollowupAppointmentReducer = createAsyncThunk(
  ACTIONS_CREATE_FOLLOWUP_APPOINTMENT.create,
  async ({ appointmentId, payload }, { rejectWithValue }) => {
    const axiosPrivate = await useAxiosPrivate();

    try {
      const response = await axiosPrivate.post(
        `${process.env.REACT_APP_API_URL}${APP_PATH.createFollowupAppointment}/${appointmentId}/create-followup`,
        payload,
      );

      if (response?.status === 200 || response?.data?.status === true) {
        toast.success(
          response?.data?.message ||
            "Follow-up appointment created successfully",
        );
        return response.data;
      } else {
        toast.error(
          response?.data?.message || "Failed to create follow-up appointment",
        );
        return rejectWithValue(response.data);
      }
    } catch (error) {
      const errMsg =
        error?.response?.data?.message ||
        "Something went wrong while creating follow-up appointment";
      toast.error(errMsg);
      return rejectWithValue(errMsg);
    }
  },
);
